import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { inject, observer } from "mobx-react";
import Select from "react-select";
import Modal from "../../Modal";

const URL_SEARCH = "/api/v1/employees.json?search={q}&method=full_name&active=true&archived=false";

@inject("messagingStorage")
@observer
class AddEmployees extends React.Component {
  state = { loading: false, visible: false, employees: [] };

  toggleModal = () => this.setState({ visible: !this.state.visible });

  handleChangeEmployees = employees => {
    this.props.messagingStorage.changeSelectUsers();
    this.setState({ employees: employees });
  };

  getEmployeeIds(employees){
    let employeesIds = [];
    for (let i = 0; i < employees.length; i++) {
      employeesIds = [...employeesIds, employees[i].value.split(",")];
    }
    return employeesIds.flat(1);
  }

  confirm = () => {
    const { loading, employees } = this.state;
    const employeesIds = this.getEmployeeIds(employees);

    if (loading) { return; }

    this.setState({ loading: true });
    axios.post(`${window.location.pathname}/employees`, { employees_ids: employeesIds })
      .then(({ data }) => {
        this.props.onAdded(data);
        this.setState({ loading: false, visible: false, employees: [] });
        toastr.success("Added");
      })
      .catch(({ response }) => {
        this.setState({ loading: false });

        if(response && response.data && response.data.message) {
          toastr.error(response.data.message);
        }
      })
    ;
  };

  render() {
    const { loading, visible, employees } = this.state;
    const { selected, messagingStorage } = this.props;

    return (
      <div>
        <button
          className="btn btn-indigo btn-raised btn-long"
          onClick={this.toggleModal}
        >
          Add Employee
        </button>

        <Modal title="Employees" visible={visible} onClose={this.toggleModal}>
          <div>
            <Select
              isMulti
              styles={{
                menuList: (base, state) => ({ ...base, maxHeight: 190 })
              }}
              className="custom-react-select"
              options={messagingStorage.groups.filter(u => !selected.includes(Number(u.value)))}
              value={messagingStorage.selectedUser}
              onChange={this.handleChangeEmployees}
            />

            <div style={{ height: 250 }}/>

            <button
              className="btn btn-pink btn-block btn-raised"
              disabled={loading || employees.length === 0}
              onClick={this.confirm}
            >
              {loading ? "SAVING..." : "SAVE"}
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

AddEmployees.propTypes = {
  selected: PropTypes.array,
  defUsers: PropTypes.array.isRequired,
  onAdded: PropTypes.func.isRequired
};

AddEmployees.defaultProps = {
  selected: []
};

export default AddEmployees;
